import { createFileRoute } from '@tanstack/react-router';
import ForfaitsPage from '../../components/webdesigned/ForfaitsPage';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/forfaits')({
  component: () => (
    <WebDesignedPortal>
      <ForfaitsPage />
    </WebDesignedPortal>
  ),
});
